module.exports = __webpack_public_path__ + "static/img/pay-success.fba3335a.png";